import Glide from './glide.esm.js'

(() => {
  const carousels = document.querySelectorAll(".glide--slider-2");

Object.values(carousels).map(carousel => {
      const slider = new Glide(carousel, {
        type: 'carousel',
        focusAt: 'center',
        perView: 3,
        perTouch: 1,
        gap: '40px',
        breakpoints: {
          989: {
            perView: 2,
            focusAt: 0,
          },
          749: {
            perView: 1.25,
            focusAt: 'center',
            gap: '5px',
          },
          380: {
            perView: 1.15,
            focusAt: 'center',
            gap: '5px',
          }
        }
      });
      slider.mount();
});


 

})()